export default {
      id: "arrow-up-left-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg/sprite.svg#arrow-up-left",
      toString: function () {
        return this.url;
      }
    }